import Webcam from "react-webcam";
import {useContext, useEffect, useState} from "react";

import Button from "./Button";
import AppContext from "../tools/contexts/AppContext";
import React from "react"
import Spinner from "./Spinner";
import {BsCameraVideoOff} from "react-icons/bs";
import {useStreamManager} from "../tools/contexts/StreamManager";

import {BiChevronRight} from "react-icons/bi"
import BottomButtonWrapper from "./BottomButtonWrapper";
import {AiOutlineQuestion} from "react-icons/ai";
import {FaQuestionCircle} from "react-icons/fa";
import {fileToBase64} from "../tools/helpers";
import imageCompression from "browser-image-compression";
import {Reoverlay} from "reoverlay";
import CropperModal from "./modals/CropperModal";
const Camera=({type,hasBack,onBack,galleryEnable,cropperEnable,theme="green",showGuide=true,onCapture,webcamRef,handleShowGuid,text,title,faceMode='environment'})=>{
    const { startStream,stopAllStreams } = useStreamManager();
    const appContext=useContext(AppContext)
    const [height,setHeight]=useState(250);
    const [width,setWidth]=useState(250);
    const [isLoading,setLoading]=useState(true);
    const [cameraError,setCameraError]=useState(null);
    const [compressLoading,setCompressLoading]=useState(false);
    const [facingMode,setFacingMode]=useState(faceMode);

    const aspect={
        nid:1,
        face:1,
        default:3/4
    }
    const dimensions={
        face:{
            width:640,
            height:640,
        },
        nid:{
            width:640,
            height:640,
        },
        default:{
            width:800,
            height:600,
        }

    }
    useEffect(()=>{
        stopAllStreams();
        if(type==="face"){
            setHeight(dimensions.face.height);
            setWidth(dimensions.face.height);
        }else if(type==="nid") {
            setHeight(dimensions.nid.height);
            setWidth(dimensions.nid.width);
        }else {
            setHeight(dimensions.default.width);
            setWidth(dimensions.default.height);
        }
    },[])
    const handleCapture = React.useCallback(
        () => {

            const imageSrc = webcamRef.current.getScreenshot( type==='face'? {
                width:dimensions.face.width,
                height:dimensions.face.height
            }:{
                width:dimensions.nid.width,
                height:dimensions.nid.height
            } );

            onCapture(imageSrc);



        },
        [webcamRef, appContext.step]
    );
    const handleChooseFromGallery=(e)=>{
    const file=e.target.files[0]
        const options = {
            maxSizeMB: 0.5,
            initialQuality:0.5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            fileType:"image/jpeg"
        }
        setCompressLoading(true)
        imageCompression(file, options).then(compressedFile=>{

            fileToBase64(compressedFile).then(base64=>{

                if(cropperEnable){
                    Reoverlay.showModal(CropperModal, {
                        name: 'برش تصویر',
                        description:'',
                        onConfirm: (image) => {
                            onCapture(image)
                            Reoverlay.hideModal()
                        },
                        image: base64
                    })
                }else {
                    onCapture(base64)
                }


            })
        }).catch(e=>{
            fileToBase64(file).then(base64=>{

                if(cropperEnable){
                    Reoverlay.showModal(CropperModal, {
                        name: 'برش تصویر',
                        description:'',
                        /*   onConfirm: (image) => {
                               onCapture(image)
                               Reoverlay.hideModal()
                           },*/
                        image: base64
                    })
                }else {
                    /*onCapture(base64)*/
                }


            })
        }).finally(()=>{

        })


    }

    return  <div className="w-full flex justify-center items-center flex-col">


        {!compressLoading&&!isLoading&&!cameraError&&   <div className="text-start w-full flex flex-col    text-center flex-col justify-center items-center mb-2    rounded mt-2">
            <div className={`flex justify-center ${(hasBack||title) ? ' border-b':''} pb-5  items-center w-full ${hasBack? 'justify-between' :'justify-center'}`}>
                {hasBack && <BiChevronRight className="text-xl  " onClick={onBack}/>}
                <strong className="text-lg flex justify-center items-center gap-2 "><span>{title}</span> <FaQuestionCircle onClick={handleShowGuid} className="text-blue-400 "/></strong>
                {hasBack && <BiChevronRight className="text-xl  opacity-0" />}
            </div>

            <p className="text-sm mt-5 mb-3 ">  {text}</p>

        </div>}

        <div className="flex justify-center items-center">
            {!isLoading&&!cameraError &&!compressLoading&&type==="face"&&     <svg className="absolute" xmlns="http://www.w3.org/2000/svg" width="97" height="132" viewBox="0 0 194 265">
                <g id="Ellipse_1" data-name="Ellipse 1" fill="none" stroke="#32bc89" strokeWidth="8" strokeDasharray="3 10">
                    <ellipse cx="97" cy="132.5" rx="97" ry="132.5" stroke="none"/>
                    <ellipse cx="97" cy="132.5" rx="93" ry="128.5" fill="none"/>
                </g>
            </svg>}

            {!compressLoading &&              <Webcam
                audio={false}
                height={height}
                width={width}

                forceScreenshotSourceSize
                screenshotFormat='image/jpeg'
                className={`${type==='face'? 'rounded-full w-56 h-56':'rounded'} overflow-hidden`}

                mirrored={false}
                videoConstraints={{
                    facingMode,
                    screenshotQuality: 1,
                    aspectRatio :type==="face" ? aspect.face: aspect.nid
                }}
                onUserMedia={(stream)=>{
                    setCameraError(null)
                    setLoading(false);
                    startStream(stream)

                }}
                onUserMediaError={(error)=>{
                    setLoading(false)
                    if(error.toString().includes('dismissed')){
                        setCameraError('از تنظیمات مرورگر خود، دسترسی به دوربین و میکروفون را فعال کنید و سپس صفحه را رفرش کنید.')
                    }else if(error.toString().includes('denied')) {
                        setCameraError('از تنظیمات مرورگر خود، دسترسی به دوربین و میکروفون را فعال کنید و سپس صفحه را رفرش کنید.')
                    }else if(error.toString().includes('Requested device not found')) {
                        setCameraError('دوربینی یافت نشد')
                    }
                    setLoading(false)
                }}
                ref={webcamRef}
            />}
        </div>
        {}
        {cameraError&&<div className="w-full  rounded-lg   text-center  p-5 text-red-500  mx-auto flex flex-col justify-center  items-center  flex justify-center items-center">
            <BsCameraVideoOff className="text-5xl text-red-500"/>
            <p className=" mt-5 w-full text-center">{cameraError}</p>
        </div>}
        {isLoading&& <div className="flex justify-center items-center flex-col">
            <Spinner className="text-xl text-green-500"/>
        </div>}
        {compressLoading&& <div className="flex justify-center h-56 flex justify-center items-end ">
            <Spinner className="text-3xl text-green-500"/>
        </div>}
        {!compressLoading&&!isLoading&&  <BottomButtonWrapper  grid={(cameraError || !galleryEnable) ? 1 :2} >
            {!compressLoading&&!isLoading&&!cameraError&&<Button onClick={handleCapture} className="w-full  " rounded="rounded-xl" theme={theme}>ثبت تصویر</Button>}
            {!compressLoading&&!isLoading&&galleryEnable&&<label htmlFor="gallery"  className="w-full text-center btn btn-light rounded-xl">
                انتخاب از گالری
                <input onChange={handleChooseFromGallery} id="gallery" accept="image/*" multiple={false} type="file" className="hidden"/>
                {/*  <div  className="w-full  md:w-5/12 lg:w-7/12 btn btn-light rounded-xl " >انتخاب از گالری</div>*/}

            </label>}

        </BottomButtonWrapper> }




    </div>
}
export default Camera


